// extracted by mini-css-extract-plugin
export default {"root":"LordIcon_root__vH2kj","clickable":"LordIcon_clickable__uyOGp","lottie":"LordIcon_lottie__f30YY","colored":"LordIcon_colored__N4wgg"};